export default "/assets/images/favicon-32x32.png?ec700220089a4d3c1ec20aa22e445d9e";